exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/course-home.js-WebpackMultiOutput";